export const TOKENS_PER_MINUTE = 60;

export function calculateTokensForDuration(minutes: number): number {
  return minutes * TOKENS_PER_MINUTE;
}

export function calculateMinutesFromTokens(tokens: number): number {
  return Math.floor(tokens / TOKENS_PER_MINUTE);
}

export function formatTokenDisplay(tokens: number): string {
  const minutes = calculateMinutesFromTokens(tokens);
  return `${tokens.toLocaleString()} tokens (${minutes} ${minutes === 1 ? 'minute' : 'minutes'})`;
}

export function formatMinutesWithTokens(minutes: number): string {
  const tokens = calculateTokensForDuration(minutes);
  return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} (${tokens.toLocaleString()} tokens)`;
}
